import React, { createRef, ReactElement, useEffect } from "react";
import { SplitPaneFullWidth, SplitPaneWidth } from "src/common";

type AllProps = {
  leftWidth: SplitPaneWidth;
  setLeftWidth: (value: number) => void;
  children: ReactElement;
};

function LeftPaneComponent(props: AllProps) {
  const { leftWidth, setLeftWidth, children } = props;
  const left_ref = createRef<HTMLDivElement>();
  useEffect(() => {
    if (left_ref.current) {
      if (!leftWidth) {
        setLeftWidth(left_ref.current.clientWidth);
        return;
      }
      left_ref.current.style.width = (leftWidth === SplitPaneFullWidth ? "100%" : `${leftWidth}px`);
    }
  }, [leftWidth]);

  return (
    <div className="left-pane" ref={left_ref}>
      {children}
    </div>
  );
}

export default React.memo(LeftPaneComponent);
